import React from 'react';
import { Grid2 as Grid, Stack, Typography } from '@mui/material';
import { ProjectSectionAccordion, ProjectSectionAccordionProps } from 'domain/shared/newProject';

interface OutcomesSensitiveAccordionProps extends Omit<ProjectSectionAccordionProps, 'title' | 'children'> {
  title: string;
  filters?: React.ReactNode;
  actions?: React.ReactElement[];
  toggleSensitiveDataButton?: Nullable<React.ReactElement>;
  isSensitiveDataIsShown?: boolean;
  reloadSensitiveData?: () => void;
  children: React.ReactElement;
}

const OutcomesSensitiveAccordion = ({
  title,
  filters,
  actions,
  children,
  toggleSensitiveDataButton,
  isSensitiveDataIsShown,
  reloadSensitiveData,
  ...props
}: OutcomesSensitiveAccordionProps) => {
  return (
    <ProjectSectionAccordion
      title={
        <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%" pl={2}>
          <Grid size={3}>
            <Typography variant="h4" color="primary">
              {title}
            </Typography>
          </Grid>
          <Grid size="auto" alignItems="center" sx={{ '.filter-item-wrapper': { m: 0 } }}>
            {filters}
          </Grid>
          <Grid size="grow" />
          <Grid size="auto">
            <Stack spacing={1} alignItems="center" justifyContent="space-between" direction="row">
              {toggleSensitiveDataButton}
              {actions}
            </Stack>
          </Grid>
        </Grid>
      }
      {...props}
    >
      {React.cloneElement(children, { isSensitiveDataIsShown })}
    </ProjectSectionAccordion>
  );
};

export default OutcomesSensitiveAccordion;
